import { create } from "zustand/react";
import type { SignalWrapper } from "@/helpers/signalr.ts";
import { HubConnectionState } from "@microsoft/signalr";

export type SignalStore = {
  signalr: SignalWrapper | null;
  status: HubConnectionState;
  Create: (wrapper: SignalWrapper) => void;
  Remove: () => void;
  SetStatus: (status: HubConnectionState) => void;
};

export const useSignalStore = create<SignalStore>()((set) => ({
  signalr: null,
  status: HubConnectionState.Disconnected,
  Create: (wrapper) =>
    set(() => ({
      signalr: wrapper,
    })),
  Remove: () => set(() => ({ signalr: null })),
  SetStatus: (status: HubConnectionState) => {
    set(() => ({
      status,
    }));
  },
}));
